(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cstm-app-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const url = new URL(window.location.href);

    const hash = window.location.hash.replace('#', '');

    if (!hash) return;

    document.querySelectorAll('.cstm-app-hero__form').forEach((wrapper) => {
      if (wrapper.dataset.formId !== hash) return;

      if (url.searchParams.has('customer_posted')) {
        wrapper.querySelector('.cstm-app-form-success')?.removeAttribute('hidden');

        return;
      }

      if (wrapper.querySelector('.banner--error')) {
        wrapper.querySelector('.cstm-app-form-error')?.removeAttribute('hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-newsletter"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

    const submittedForm = sessionStorage.getItem('submittedNewsletter');

    if (!submittedForm) return;

    document.querySelectorAll('.cstm-newsletter-form-wrapper').forEach(wrapper => {

        if (wrapper.dataset.formId !== submittedForm)
            return;

        if (window.location.search.includes('customer_posted=true')) {

            wrapper
                .querySelector('.cstm-newsletter-success')
                ?.removeAttribute('hidden');

        } else {

            wrapper
                .querySelector('.cstm-newsletter-error')
                ?.removeAttribute('hidden');

        }

    });

    sessionStorage.removeItem('submittedNewsletter');

});

document.addEventListener('submit', function(e){

    const form = e.target;

    if(!form.matches('form[action*="/contact"]'))
        return;

    sessionStorage.setItem(
        'submittedNewsletter',
        form.id
    );

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-text-with-media"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-item').forEach((item) => {
    const button = item.querySelector('.faq-question');
    const wrapper = item.querySelector('.faq-answer-wrapper');

    button.addEventListener('click', () => {
      const isOpen = item.classList.contains('active');

      if (isOpen) {
        wrapper.style.maxHeight = wrapper.scrollHeight + 'px';

        requestAnimationFrame(() => {
          wrapper.style.maxHeight = '0px';
        });

        item.classList.remove('active');
        button.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('active');
        button.setAttribute('aria-expanded', 'true');

        wrapper.style.maxHeight = wrapper.scrollHeight + 'px';

        wrapper.addEventListener('transitionend', function handler() {
          wrapper.style.maxHeight = 'none';
          wrapper.removeEventListener('transitionend', handler);
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
